import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';

export interface AdminCover {
  id: string;
  imageUrl: string;
  filename: string | null;
  createdAt: string;
}

export const coversApi = createApi({
  reducerPath: 'coversApi',
  baseQuery,
  tagTypes: ['CoverList'],
  endpoints: (builder) => ({
    listCovers: builder.query<AdminCover[], void>({
      query: () => ({ url: '/admin/covers' }),
      providesTags: ['CoverList'],
    }),
    uploadCover: builder.mutation<AdminCover, FormData>({
      query: (body) => ({
        url: '/admin/covers/upload',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['CoverList'],
    }),
    deleteCover: builder.mutation<{ success: boolean }, string>({
      query: (id) => ({
        url: `/admin/covers/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['CoverList'],
    }),
  }),
});

export const {
  useListCoversQuery,
  useUploadCoverMutation,
  useDeleteCoverMutation,
} = coversApi;
